module.exports = "/assets/data/649e8b84e0b8f8fbfd724a5c93699d2f-EC4A.data.json";